import {createReducer} from '@reduxjs/toolkit';
import {
  setByCoordinate as setGeometryByCoordinate,
  setByExtent as setGeometryByExtent,
} from '../actions/geometry.js';
import {
  includeExtent,
  setExtent,
  setView,
  setZoomLevel,
} from '../actions/map.js';
import setActiveQuad from '../actions/set-active-quad.js';
import {MIN_POINT_ZOOM_LEVEL} from '../common.js';

function boxesOverlap(a, b) {
  return !(a[2] < b[0] || a[0] > b[2] || a[3] < b[1] || a[1] > b[3]);
}

export const initialState = {
  center: [0, 0],
  extent: undefined,
  zoom: 2,
};

export default createReducer(initialState, builder => {
  builder.addCase(includeExtent, (state, {payload: extent}) => {
    if (state.extent && !boxesOverlap(state.extent, extent)) {
      return {extent};
    }
    return state;
  });

  builder.addCase(setExtent, (state, {payload: extent}) => {
    state.extent = extent;
  });

  builder.addCase(setView, (state, {payload}) => {
    state.center = payload.center || state.center;
    state.extent = payload.extent || state.extent;
    state.zoom = payload.zoom || state.zoom;
  });

  builder.addCase(setZoomLevel, (state, {payload: zoom}) => {
    state.zoom = Math.max(1, zoom);
  });

  builder.addCase(setGeometryByCoordinate, (state, {payload: center}) => {
    state.center = center;
    state.zoom = Math.max(MIN_POINT_ZOOM_LEVEL, state.zoom);
  });

  builder.addCase(setGeometryByExtent, (state, {payload: extent}) => {
    state.extent = extent;
  });

  builder.addCase(setActiveQuad, (state, {payload: quad}) => {
    if (!quad) {
      return state;
    }

    state.extent = quad.bbox;
  });
});
